import { render } from "./InviteForm.vue?vue&type=template&id=5d055063"
import script from "./InviteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/coaching_user/components/InviteForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d055063"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d055063', __exports__)) {
    api.reload('5d055063', __exports__)
  }
  
  module.hot.accept("./InviteForm.vue?vue&type=template&id=5d055063", () => {
    api.rerender('5d055063', render)
  })

}


export default __exports__